import React, { useEffect, useRef, useState } from 'react';

import PropTypes from 'prop-types';

import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';

import { useHandleCloseDropdownMenu } from 'hooks/useHandleCloseDropdownMenu';

import styles from './DropdownList.module.css';

export const DropdownList = (props) => {
    const wrapperRef = useRef(null);
    const [isOpenDropdownMenu, setOpenDropdownMenu] = useHandleCloseDropdownMenu(wrapperRef);

    const isControlled = props.selectedValue !== undefined;
    const [internalSelected, setInternalSelected] = useState(props.selectedValue || props.listItems[0]?.value);
    const selectedValue = isControlled ? props.selectedValue : internalSelected;

    useEffect(() => {
        if (isControlled) {
            setInternalSelected(props.selectedValue);
        }
    }, [props.selectedValue, isControlled]);

    const handleSelectChange = (item) => {
        setOpenDropdownMenu(false);
        if (!isControlled) {
            setInternalSelected(item.value);
        }
        if (props.onSelectChange) {
            props.onSelectChange(item);
        }
    };

    return (
        <div className={`${styles.container} ${props.isBordered ? styles.containerBordered : ''}`} ref={wrapperRef}>
            <div className={`${styles.inputContainer} ${props.isBordered ? styles.inputContainerBordered : ''}`} onClick={() => setOpenDropdownMenu(true)}>
                <div className={styles.placeholder}>
                    <PromoText tag="div" color={'white'} isBold ellipsis nowrap>
                        {selectedValue}
                    </PromoText>
                </div>
                <PromoIcon name="chevron-down" color="white" size="16px" />
            </div>
            {isOpenDropdownMenu && (
                <div className={styles.dropdownList}>
                    {props.listItems.map((item, index) => {
                        const isSelected = selectedValue === item.value;
                        return (
                            <div
                                key={index}
                                className={`${styles.dropdownItem} ${isSelected ? styles.dropdownItemSelected : ''}`}
                                onClick={() => handleSelectChange(item)}
                            >
                                <PromoText color="white" isBold nowrap>
                                    {item.value}
                                </PromoText>
                                {isSelected && <PromoIcon name="check" color="white" size="16px" leftIndent={'8px'} />}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

DropdownList.propTypes = {
    listItems: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    selectedValue: PropTypes.string,
    isBordered: PropTypes.bool,
};
